import { useState, useEffect } from "react";
import "./choose_week.css";
import { apiFetch } from "../../config";

function ChooseWeek({ selectedWeek, setSelectedWeek }) {
    const [weeks, setWeeks] = useState([]);

    useEffect(() => {
        apiFetch("/semaines")
            .then((response) => response.json())
            .then((data) => setWeeks(data))
            .catch((error) => console.error("Erreur récupération semaines :", error));
    }, []);

  return (
    <div className="ChooseWeek">
        <label htmlFor="week-select">Choisir une semaine :</label>
        <select
            id="week-select"
            value={selectedWeek}
            onChange={(e) => setSelectedWeek(e.target.value)}
        >
            <option value="">--Sélectionner--</option>
            {weeks.map((week) => (
                <option key={week.nom} value={week.nom}>
                    {week.nom}
                </option>
            ))}
        </select>
    </div>
  );
}

export default ChooseWeek;